import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectAssistance, assistanceListUpdateSelected } from "../../app/actions/assistanceActions";
import { registerPanelViewInterest } from "../../app/helpers/intentTrackingHelper";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import L5ModalAssistance from "./L5ModalAssistance";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { useTranslation } from "react-i18next";
import SemanticSimilarityBadge from "./SemanticSimilarityBadge";

const L4CardAssistance = ({ data, moduleSelected }) => {

  debugLogPages(":: L4CardAssistance")

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { comparisonAssistanceCheckEnabled } = useSelector((state) => state.configuration);

  const { numberAssistanceSelected } = useSelector((state) => state.assistance);

  const [checked] = useState(false);

  const [popupInformationTechIsOpen, setPopupInformationTechIsOpen] = useState(false);

  const isChecked = data.isSelected;

  const handleToggle = () => {
      dispatch(assistanceListUpdateSelected(data.id));
    };

  const closeModal = () => {
    setPopupInformationTechIsOpen(false);
  }

  const handleViewAssistance = (e) => {
    e.preventDefault();
    dispatch(selectAssistance(data));
    registerPanelViewInterest(dispatch, 'assistance', data);
     navigate(`/end-user-search/preview-assistance`);
  };

  const PreviewImageShow = () => {
  // Imagen por defecto
  //const defaultImg = "/Modulos/TecBC.png";
  const defaultImg = '/images/logo_teccc_no_disponible.png'

  const handleImgError = (e) => {
    // Si la imagen falla, reemplazamos el src por la de defecto
    e.target.src = defaultImg;
    // Opcional: puedes quitar el atributo onError para evitar bucles si la de defecto también falla
    e.target.onerror = null; 
  };

  if (data.ModuleFile_To_Assistance && data.ModuleFile_To_Assistance.length > 0) {
    return (
      <img 
        src={data.ModuleFile_To_Assistance[0].url} 
        alt="file" 
        onError={handleImgError} // <-- El truco está aquí
      />
    );
  } else {
    return (
      <div>
        <img src={defaultImg} width="300px" alt="technology" />
      </div>
    );
  }
};

  const handlePopupSwall = (e) => {
    e.preventDefault();
    registerPanelViewInterest(dispatch, 'assistance', data);

    setPopupInformationTechIsOpen(true);
  };

    debugLogPages(':: L4CardAssistance', {numberAssistanceSelected:numberAssistanceSelected});

  return (
    <li className="cards__item">
      <div className="card"
      >
        {comparisonAssistanceCheckEnabled === "true" && <div>
          <label>
            <input
              type="checkbox"
              checked={isChecked} 
              onChange={handleToggle}
            />
            <div className="espacioComparar">{checked ? `${t('general.card-selected')}` : `${t('general.card-select')}`}</div>
          </label>
        </div>}
        <div className="card__image" onClick={handlePopupSwall}>
          <PreviewImageShow />
        </div>
        <div className="card__content">
          <SemanticSimilarityBadge data={data} moduleKey="assistance" />
          <div className="card__title">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.name}
            </ReadMoreReadLess>
          </div>
          <br />
          <div className="card__text">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.description}
            </ReadMoreReadLess>
          </div>
          <button className="btn btn--block button-color-view" onClick={handleViewAssistance}>
            {t("buttons.view")}
          </button>
        </div>
      </div>

      <L5ModalAssistance
        modalIsOpen={popupInformationTechIsOpen}
        closeModal={closeModal}
        data={data}
        moduleSelected={moduleSelected}
      />
  
    </li>
  );
};

export default L4CardAssistance;
